import Loadable from '../../components/loadable';

const MembershipPlansList = Loadable({
  loader: () => import('react/pages/membership_plans/membership_plans_list'),
  type: 'block',
});

angular.module('gym').value('MembershipPlansList', MembershipPlansList);

const MembershipPlansListFiltersModal = Loadable({
  loader: () => import('react/pages/membership_plans/membership_plans_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('MembershipPlansListFiltersModal', MembershipPlansListFiltersModal);
